import { PageShell } from "./PageShell";

/** Shown for any path that is not the game or one of the three static pages. */
export function NotFoundPage() {
  return (
    <PageShell title="page not found">
      <p>There is nothing at this address.</p>
    </PageShell>
  );
}
